import { DASHBOARD_ENDPOINTS } from '../constants/endpoints'
import { httpClient } from './httpClient'

// Create dashboard
export const createDashboard = (params) => {
  return httpClient.post(DASHBOARD_ENDPOINTS.DASHBOARDS, params)
}
// Update dashboard
export const updateDashboard = (dashboardId, params) => {
  return httpClient.put(DASHBOARD_ENDPOINTS.DASHBOARD_BY_ID(dashboardId), params)
}
// Delete dashboard
export const delDashboard = (dashboardId) => {
  return httpClient.delete(DASHBOARD_ENDPOINTS.DASHBOARD_BY_ID(dashboardId))
}
// Dynamic module readings
export const getDynamicModuleReadings = (
  page,
  devices,
  deviceIdentifier,
  location,
  rangeStart,
  rangeEnd,
  tz,
  paginate,
  limit,
  moduleId,
  moduleType,
) => {
  return httpClient.get(DASHBOARD_ENDPOINTS.DYNAMIC_MODULE_READINGS(moduleId), {
    params: {
      page,
      moduleType,
      ...(limit && { limit }),
      ...(devices && { devices }),
      ...(deviceIdentifier && { deviceIdentifier }),
      ...(location && { location }),
      ...(rangeStart && { range_start: rangeStart }),
      ...(rangeEnd && { range_end: rangeEnd }),
      ...(tz && { tz }),
      ...(paginate !== undefined && { paginate }),
    },
  })
}
// Settings application
export const fetchAppSettings = () => {
  return httpClient.get(DASHBOARD_ENDPOINTS.APP_SETTINGS)
}
